var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnookerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "23px",
    viewBox: "0 0 25 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-668.000000, -474.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(663.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillRule: "nonzero",
    cx: 12.2,
    cy: 4,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "nonzero",
    cx: 16.3,
    cy: 11.6,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "nonzero",
    cx: 20.7,
    cy: 19.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "nonzero",
    cx: 8.2,
    cy: 11.6,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "nonzero",
    cx: 3.8,
    cy: 19.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "nonzero",
    cx: 12.2,
    cy: 19.3,
    r: 3.6
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnookerWhite);
export default __webpack_public_path__ + "static/media/snookerWhite.cbca19628503309e1521519e738f8752.svg";
export { ForwardRef as ReactComponent };